import { EventActivity, LeadActivity, ModelID } from '@/types';
import { post } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';

export interface AvailabilityResponse {
  asset_id: number;
  activity_id: number;
  available: boolean;
  gap_next: number | null;
  gap_prev: number | null;
  reason: string | null;
  warning: string | null;
  travel_next: number | null;
  travel_next_is_depot: boolean;
  travel_next_status: string;
  travel_prev: number | null;
  travel_prev_is_depot: boolean;
  travel_prev_status: string;
}

interface AvailabilityLookupParams {
  activity: LeadActivity | EventActivity;
  location_id: ModelID;
  forcePastLookup: boolean;
}

const getAvailability = (
  location_id: ModelID,
  activity: LeadActivity | EventActivity,
  force_past_travel: boolean,
) => {
  let config = {};

  if ('event_id' in activity) {
    config = {
      event_id: activity.event_id,
      mode: 'event',
      force_past_travel,
    };
  } else {
    config = {
      lead_id: activity.lead_id,
      mode: 'lead',
      force_past_travel,
    };
  }

  return post<AvailabilityResponse[]>(
    `/v4/franchises/franchise/${location_id}/get-availability`,
    config,
  );
};

export const useAvailability = ({
  activity,
  location_id,
  forcePastLookup,
}: AvailabilityLookupParams) =>
  useQuery({
    queryKey: [
      'availability',
      { id: 'event_id' in activity ? activity.event_id : activity.lead_id },
    ],
    queryFn: () => getAvailability(location_id, activity, forcePastLookup),
    enabled: forcePastLookup,
  });
